export const getMathModals = () => {
    return {
        dialogs: document.querySelectorAll(".wrs_modal_dialogContainer"),
        overlays: document.querySelectorAll(".wrs_modal_overlay"),
    };
};
